import {
  AwardIcon,
  BriefcaseBusinessIcon,
  Building2Icon,
  ClockIcon,
  CoinsIcon,
  HandshakeIcon,
  RocketIcon,
  UserIcon,
  UsersIcon,
} from '@ramp106/omrjs-core-ui/icons'

import type { TitleIconEnum } from '@/gql/reviews'

// Maps the API's TitleIconEnum values to the corresponding lucide-vue
// components from omrjs-core-ui. Kept in lockstep with the enum on the
// reviews-api side (PricingPlan::TITLE_ICONS) so the editor and the
// preview render identical icons.
//
// Keyed by the enum's string values directly (not `TitleIconEnum.X`) so
// this module has no runtime dependency on the generated GraphQL
// exports — several existing specs hard-mock `@/gql/reviews` without
// `importOriginal`, and any runtime access to the enum from a
// transitively-loaded module would throw inside those tests.
export const titleIconRegistry: Record<TitleIconEnum, typeof AwardIcon> = {
  AwardIcon,
  BriefcaseBusinessIcon,
  Building2Icon,
  ClockIcon,
  CoinsIcon,
  HandshakeIcon,
  RocketIcon,
  UserIcon,
  UsersIcon,
}
